<div class="view">
  <div class="head">
    <app-breadcrumb [constructor_name]="constructor.name"></app-breadcrumb>
  </div>
  <div class="body">
    <div [style.margin]="'0px 0px -6.5px 0px'">
      <img
        src="https://wikipapa.org/images/banner-guardianes.jpg"
        style="object-fit: contain; background-size: cover"
        width="100%"
      />
    </div>

    <div
      fxLayout="row wrap"
      fxLayoutAlign="space-around center"
      [style.background-color]="'#FFFFC5'"
      [style.padding]="'0% 20%'"
    >
      <div [style.padding]="'0em 2em'">
        <p class="p1">
          Los guardianes de la papa son un grupo de personas dedicadas a la
          agricultura familiar que cultivan de forma tradicional y ecológica una
          gran diversidad de papas nativas. Los guardianes de la papa juegan un
          rol importante en la seguridad alimentaria del Perú.
        </p>
      </div>
    </div>
    <br />
    <div style="padding: 0 12% 3% 12%">
      <div fxLayout="row wrap" fxLayoutAlign="space-between center">
        <div fxFlex="100">
          <span
            style="
              font-family: Raleway, sans-serif;
              color: #8b0032;
              font-size: 28pt;
              font-weight: 700;
            "
          >
            Conoce nuestros guardianes:
          </span>
        </div>
      </div>
    </div>
    <div style="padding: 0 8%">
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">
        <mat-tab label="Huancavelica">
          <h2 style="text-align: center">Huancavelica</h2>
          <div style="padding: 1% 0% 10% 0%">
            <div
              fxLayout="row wrap"
              fxLayoutAlign="space-between"
              fxLayoutGap="2"
            >
              <div
                *ngFor="let guardian_card of guardian_card_list_1"
                fxFlex="{{ guardian_card.width_lg }}"
                fxFlex.md="{{ guardian_card.width_md }}"
                fxFlex.sm="100"
                fxFlex.xs="100"
                [style.padding-bottom]="'30px'"
              >
                <div
                  *ngIf="
                    guardian_card.design == 'ver_1' ||
                    guardian_card.design == 'ver_2'
                  "
                  [style.box-shadow]="'rgba(0, 0, 0, 0.35) 0px 5px 15px'"
                >
                  <div [style.margin]="'0px 0px -6.5px 0px'">
                    <img
                      src="{{ guardian_card.url_img }}"
                      style="object-fit: contain; background-size: cover"
                      width="100%"
                    />
                  </div>
                </div>
                <div
                  [style.width]="'100%'"
                  [style.background-color]="guardian_card.bg_color"
                  [style.box-shadow]="'rgba(0, 0, 0, 0.35) 0px 5px 15px'"
                  fxLayout="row"
                  fxLayoutAlign="space-between start"
                >
                  <div
                    fxFlex="50"
                    *ngIf="guardian_card.design == 'hor_1'"
                    [ngStyle]="{
                      'background-image': 'url(' + guardian_card.url_img + ')'
                    }"
                    style="
                      background-repeat: no-repeat;
                      background-attachment: inherit;
                      background-size: 100% 100%;
                      width: 325px;
                      height: 280px;
                    "
                  ></div>
                  <div
                    fxFlex="{{ guardian_card.fxFlex }}"
                    [style.padding]="'20px'"
                    fxLayout="column"
                    fxLayoutAlign="start stretch"
                  >
                    <div
                      class="p2 text-truncate-line"
                      style="text-align: left; border-bottom: solid 2px #46003d"
                      title="{{ guardian_card.title }}"
                    >
                      {{ guardian_card.title }}
                    </div>
                    <div
                      class="p3"
                      [style.text-align]="'start'"
                      [style.min-height]="guardian_card.min_height"
                    >
                      {{ guardian_card.information }}
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between end">
                      <button
                        mat-stroked-button
                        (click)="openPdf(guardian_card.url_pdf)"
                        type="button"
                      >
                        <span class="text-truncate-line">Leer más</span>
                      </button>
                      <img
                        src="{{ guardian_card.url_qr }}"
                        style="object-fit: contain; background-size: cover"
                        width="80px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Huánuco">
          <h2 style="text-align: center">Huánuco</h2>
          <div style="padding: 1% 0% 10% 0%">
            <div
              fxLayout="row wrap"
              fxLayoutAlign="space-between"
              fxLayoutGap="2"
            >
              <div
                *ngFor="let guardian_card of guardian_card_list_2"
                fxFlex="{{ guardian_card.width_lg }}"
                fxFlex.md="{{ guardian_card.width_md }}"
                fxFlex.sm="100"
                fxFlex.xs="100"
                [style.padding-bottom]="'30px'"
              >
                <div
                  *ngIf="
                    guardian_card.design == 'ver_1' ||
                    guardian_card.design == 'ver_2'
                  "
                  [style.box-shadow]="'rgba(0, 0, 0, 0.35) 0px 5px 15px'"
                >
                  <div [style.margin]="'0px 0px -6.5px 0px'">
                    <img
                      src="{{ guardian_card.url_img }}"
                      style="object-fit: contain; background-size: cover"
                      width="100%"
                    />
                  </div>
                </div>
                <div
                  [style.width]="'100%'"
                  [style.background-color]="guardian_card.bg_color"
                  [style.box-shadow]="'rgba(0, 0, 0, 0.35) 0px 5px 15px'"
                  fxLayout="row"
                  fxLayoutAlign="space-between start"
                >
                  <div
                    fxFlex="50"
                    *ngIf="guardian_card.design == 'hor_1'"
                    [ngStyle]="{
                      'background-image': 'url(' + guardian_card.url_img + ')'
                    }"
                    style="
                      background-repeat: no-repeat;
                      background-attachment: inherit;
                      background-size: 100% 100%;
                      width: 325px;
                      height: 280px;
                    "
                  ></div>
                  <div
                    fxFlex="{{ guardian_card.fxFlex }}"
                    [style.padding]="'20px'"
                    fxLayout="column"
                    fxLayoutAlign="start stretch"
                  >
                    <div
                      class="p2 text-truncate-line"
                      style="text-align: left; border-bottom: solid 2px #46003d"
                      title="{{ guardian_card.title }}"
                    >
                      {{ guardian_card.title }}
                    </div>
                    <div
                      class="p3"
                      [style.text-align]="'start'"
                      [style.min-height]="guardian_card.min_height"
                    >
                      {{ guardian_card.information }}
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between end">
                      <button
                        mat-stroked-button
                        (click)="openPdf(guardian_card.url_pdf)"
                        type="button"
                      >
                        <span class="text-truncate-line">Leer más</span>
                      </button>
                      <img
                        src="{{ guardian_card.url_qr }}"
                        style="object-fit: contain; background-size: cover"
                        width="80px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Junín">
          <h2 style="text-align: center">Junín</h2>
          <div style="padding: 1% 0% 10% 0%">
            <div
              fxLayout="row wrap"
              fxLayoutAlign="space-between"
              fxLayoutGap="2"
            >
              <div
                *ngFor="let guardian_card of guardian_card_list_3"
                fxFlex="{{ guardian_card.width_lg }}"
                fxFlex.md="{{ guardian_card.width_md }}"
                fxFlex.sm="100"
                fxFlex.xs="100"
                [style.padding-bottom]="'30px'"
              >
                <div
                  *ngIf="
                    guardian_card.design == 'ver_1' ||
                    guardian_card.design == 'ver_2'
                  "
                  [style.box-shadow]="'rgba(0, 0, 0, 0.35) 0px 5px 15px'"
                >
                  <div [style.margin]="'0px 0px -6.5px 0px'">
                    <img
                      src="{{ guardian_card.url_img }}"
                      style="object-fit: contain; background-size: cover"
                      width="100%"
                    />
                  </div>
                </div>
                <div
                  [style.width]="'100%'"
                  [style.background-color]="guardian_card.bg_color"
                  [style.box-shadow]="'rgba(0, 0, 0, 0.35) 0px 5px 15px'"
                  fxLayout="row"
                  fxLayoutAlign="space-between start"
                >
                  <div
                    fxFlex="50"
                    *ngIf="guardian_card.design == 'hor_1'"
                    [ngStyle]="{
                      'background-image': 'url(' + guardian_card.url_img + ')'
                    }"
                    style="
                      background-repeat: no-repeat;
                      background-attachment: inherit;
                      background-size: 100% 100%;
                      width: 325px;
                      height: 280px;
                    "
                  ></div>
                  <div
                    fxFlex="{{ guardian_card.fxFlex }}"
                    [style.padding]="'20px'"
                    fxLayout="column"
                    fxLayoutAlign="start stretch"
                  >
                    <div
                      class="p2 text-truncate-line"
                      style="text-align: left; border-bottom: solid 2px #46003d"
                      title="{{ guardian_card.title }}"
                    >
                      {{ guardian_card.title }}
                    </div>
                    <div
                      class="p3"
                      [style.text-align]="'start'"
                      [style.min-height]="guardian_card.min_height"
                    >
                      {{ guardian_card.information }}
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between end">
                      <button
                        mat-stroked-button
                        (click)="openPdf(guardian_card.url_pdf)"
                        type="button"
                      >
                        <span class="text-truncate-line">Leer más</span>
                      </button>
                      <img
                        src="{{ guardian_card.url_qr }}"
                        style="object-fit: contain; background-size: cover"
                        width="80px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Lima">
          <h2 style="text-align: center">Lima</h2>
          <div style="padding: 1% 0% 10% 0%">
            <div
              fxLayout="row wrap"
              fxLayoutAlign="space-between"
              fxLayoutGap="2"
            >
              <div
                *ngFor="let guardian_card of guardian_card_list_4"
                fxFlex="{{ guardian_card.width_lg }}"
                fxFlex.md="{{ guardian_card.width_md }}"
                fxFlex.sm="100"
                fxFlex.xs="100"
                [style.padding-bottom]="'30px'"
              >
                <div
                  *ngIf="
                    guardian_card.design == 'ver_1' ||
                    guardian_card.design == 'ver_2'
                  "
                  [style.box-shadow]="'rgba(0, 0, 0, 0.35) 0px 5px 15px'"
                >
                  <div [style.margin]="'0px 0px -6.5px 0px'">
                    <img
                      src="{{ guardian_card.url_img }}"
                      style="object-fit: contain; background-size: cover"
                      width="100%"
                    />
                  </div>
                </div>
                <div
                  [style.width]="'100%'"
                  [style.background-color]="guardian_card.bg_color"
                  [style.box-shadow]="'rgba(0, 0, 0, 0.35) 0px 5px 15px'"
                  fxLayout="row"
                  fxLayoutAlign="space-between start"
                >
                  <div
                    fxFlex="50"
                    *ngIf="guardian_card.design == 'hor_1'"
                    [ngStyle]="{
                      'background-image': 'url(' + guardian_card.url_img + ')'
                    }"
                    style="
                      background-repeat: no-repeat;
                      background-attachment: inherit;
                      background-size: 100% 100%;
                      width: 325px;
                      height: 280px;
                    "
                  ></div>
                  <div
                    fxFlex="{{ guardian_card.fxFlex }}"
                    [style.padding]="'20px'"
                    fxLayout="column"
                    fxLayoutAlign="start stretch"
                  >
                    <div
                      class="p2 text-truncate-line"
                      style="text-align: left; border-bottom: solid 2px #46003d"
                      title="{{ guardian_card.title }}"
                    >
                      {{ guardian_card.title }}
                    </div>
                    <div
                      class="p3"
                      [style.text-align]="'start'"
                      [style.min-height]="guardian_card.min_height"
                    >
                      {{ guardian_card.information }}
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between end">
                      <button
                        mat-stroked-button
                        (click)="openPdf(guardian_card.url_pdf)"
                        type="button"
                      >
                        <span class="text-truncate-line">Leer más</span>
                      </button>
                      <img
                        src="{{ guardian_card.url_qr }}"
                        style="object-fit: contain; background-size: cover"
                        width="80px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
        <mat-tab label="Pasco">
          <h2 style="text-align: center">Pasco</h2>
          <div style="padding: 1% 0% 10% 0%">
            <div
              fxLayout="row wrap"
              fxLayoutAlign="space-between"
              fxLayoutGap="2"
            >
              <div
                *ngFor="let guardian_card of guardian_card_list_5"
                fxFlex="{{ guardian_card.width_lg }}"
                fxFlex.md="{{ guardian_card.width_md }}"
                fxFlex.sm="100"
                fxFlex.xs="100"
                [style.padding-bottom]="'30px'"
              >
                <div
                  *ngIf="
                    guardian_card.design == 'ver_1' ||
                    guardian_card.design == 'ver_2'
                  "
                  [style.box-shadow]="'rgba(0, 0, 0, 0.35) 0px 5px 15px'"
                >
                  <div [style.margin]="'0px 0px -6.5px 0px'">
                    <img
                      src="{{ guardian_card.url_img }}"
                      style="object-fit: contain; background-size: cover"
                      width="100%"
                    />
                  </div>
                </div>
                <div
                  [style.width]="'100%'"
                  [style.background-color]="guardian_card.bg_color"
                  [style.box-shadow]="'rgba(0, 0, 0, 0.35) 0px 5px 15px'"
                  fxLayout="row"
                  fxLayoutAlign="space-between start"
                >
                  <div
                    fxFlex="50"
                    *ngIf="guardian_card.design == 'hor_1'"
                    [ngStyle]="{
                      'background-image': 'url(' + guardian_card.url_img + ')'
                    }"
                    style="
                      background-repeat: no-repeat;
                      background-attachment: inherit;
                      background-size: 100% 100%;
                      width: 325px;
                      height: 280px;
                    "
                  ></div>
                  <div
                    fxFlex="{{ guardian_card.fxFlex }}"
                    [style.padding]="'20px'"
                    fxLayout="column"
                    fxLayoutAlign="start stretch"
                  >
                    <div
                      class="p2 text-truncate-line"
                      style="text-align: left; border-bottom: solid 2px #46003d"
                      title="{{ guardian_card.title }}"
                    >
                      {{ guardian_card.title }}
                    </div>
                    <div
                      class="p3"
                      [style.text-align]="'start'"
                      [style.min-height]="guardian_card.min_height"
                    >
                      {{ guardian_card.information }}
                    </div>
                    <div fxLayout="row" fxLayoutAlign="space-between end">
                      <button
                        mat-stroked-button
                        (click)="openPdf(guardian_card.url_pdf)"
                        type="button"
                      >
                        <span class="text-truncate-line">Leer más</span>
                      </button>
                      <img
                        src="{{ guardian_card.url_qr }}"
                        style="object-fit: contain; background-size: cover"
                        width="80px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
